import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const UserManagementModalHeader = ({
  title,
  onClose,
  showCloseIcon = true,
}) => (
  <Box className="d-flex align-items-start justify-content-between mb-3">
    <Box className="d-flex align-items-center">
      <Box className="d-flex align-items-center justify-content-center mr-3">
        <RpSvgIcon name="user_add" size={34} color="primary" />
      </Box>
      <Typography variant="h6" className="font-weight-bold">
        {title}
      </Typography>
    </Box>

    {showCloseIcon && (
      <IconButton aria-label="close" onClick={onClose} size="small">
        <CloseIcon />
      </IconButton>
    )}
  </Box>
);

UserManagementModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  showCloseIcon: PropTypes.bool,
};

export default UserManagementModalHeader;
